
import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { CreditCard } from "lucide-react";

interface ArchivedListingRestoreDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  hasCredits: boolean;
}

const ArchivedListingRestoreDialog: React.FC<ArchivedListingRestoreDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  hasCredits,
}) => {
  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center">
            <CreditCard className="mr-2 h-5 w-5 text-amber-500" />
            <span>Riaktivizo Shpalljen nga Arkiva</span>
          </AlertDialogTitle>
          <AlertDialogDescription>
            {hasCredits ? (
              <div>
                <p className="mb-2">
                  Riaktivizimi i një shpalljeje nga arkiva kushton 1 kredit.
                </p>
                <p>
                  Me riaktivizimin, shpallja juaj do të shfaqet sërish në listën e shpalljeve aktive
                  dhe do të jetë e dukshme për blerësit potencialë.
                </p>
              </div>
            ) : (
              <div>
                <p className="mb-2 text-red-500 font-semibold">
                  Ju nuk keni kredite të mjaftueshme për të riaktivizuar këtë shpallje.
                </p>
                <p>
                  Ju duhet të blini kredite shtesë për të riaktivizuar shpalljen.
                </p>
              </div>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onClose}>Anulo</AlertDialogCancel>
          {hasCredits && (
            <AlertDialogAction
              onClick={onConfirm}
              className="bg-amber-500 hover:bg-amber-600"
            >
              Konfirmo dhe Riaktivizo
            </AlertDialogAction>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ArchivedListingRestoreDialog;
